<template>
    <div>
        <!-- 客户回访 -->
        <el-form :rules="rules" ref="form" :model="form" label-width="100px">
            <el-form-item label="回访结果">
                <el-radio v-model="form.solutionResult" label="1">已解决</el-radio>
                <el-radio v-model="form.solutionResult" label="2">未解决</el-radio>
            </el-form-item>
            <el-form-item label="满意度">
                <el-rate v-model="form.satisfaction"></el-rate>
            </el-form-item>
            <el-form-item label="快速备注回访">
                <el-select v-model="form.remark" placeholder="请选择" @change="remarkFn">
                    <el-option v-for="item in remarkList" :key="item.id" :label="item.name"
                               :value="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="处理意见">
                <el-input type="textarea" v-model="form.handleComment"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="submit" :disabled="isSubmit">确定</el-button>
                <el-button type="default" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import services from "../../services/common.service"
    export default {
        props:{
            serialNumber:String,
            callback:Function,
        },
        data() {
            return {
                rules:{},
                form:{
                    solutionResult:"1",
                    satisfaction:5,
                    remark:"",
                    handleComment:"",
                    notify:[]
                },
                notifyUserid:[],
                remarkList:[
                    { id:"1",name:"问题已解决,非常感谢"},
                    { id:"2",name:"未解决，需要技术人员再次跟进"},
                ],
                isSubmit:false
            }
        },
        created() {

        },
        methods: {
            remarkFn(val){
                this.form.handleComment = val;
            },
            submit(){
                this.isSubmit=true
                this.notifyUserid=this.form.notify&&this.form.notify.map(item=>{return item.userid})
                let params = {
                    ...this.form,
                    handle:"客户回访",
                    serialNumber:this.serialNumber,
                    notify:this.notifyUserid
                }
                services.eventHandle(params).then(res => {
                    this.$message.success("客户回访成功");
                    this.callback();
                    // console.log(1);
                    this.$modal.close();
                }).catch(err => {
                    this.isSubmit=false
                    this.$message.error(err.message);
                })
            },
            //将选择的知会人信息去重保存
            getNoticer(obj){
                this.form.notify=this.arrayUnique(this.form.notify.concat(obj))
            },
            //删除后显示剩余的知会人
            getNotifyData(val){
                this.form.notify=val
            },
            //选择完知会人后去重，此方法可通用于包含对象的数组深层次去重
            arrayUnique(arr){
                let obj={}
                let newArr = []
                arr.forEach(item=>{
                    if(!obj[item.id]){
                        obj[item.id]=1
                        newArr.push(item)
                    }
                })
                return newArr

            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .noticeAdd{
        color: #1890ff;
        font-size: 27px;
        position: relative;
        top: -2px;
        margin-left: 10px;
    }
</style>
